import { DestinationList } from "../constants/Destinations";

export const findDisplayNameById = (id: any) => {
  const destination = DestinationList?.find((item) => item["Searc ID"] === id);
  return destination ? destination["Display Name #1"] : "";
};
